import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { isIosMobileBrowser } from '../../../../base/environment/utils';
import { translate } from '../../../../base/i18n/functions';
import Icon from '../../../../base/icons/components/Icon';
import { IconCopy, IconEnvelope, IconGoogle, IconOffice365, IconYahoo } from '../../../../base/icons/svg';
import Tooltip from '../../../../base/tooltip/components/Tooltip';
import { copyText } from '../../../../base/util/copyText.web';
let mounted;
const useStyles = makeStyles()(theme => {
    return {
        container: {
            marginBottom: theme.spacing(3)
        },
        label: {
            marginBottom: theme.spacing(1)
        },
        iconRow: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        },
        iconContainer: {
            display: "block",
            padding: theme.spacing(2),
            cursor: "pointer",
            "& svg": {
                fill: theme.palette.iisightIcon
            }
        }
    };
});
/**
 * Component that renders email invite options.
 *
 * @returns {ReactNode}
 */
function InviteByEmailSection({ inviteSubject, inviteText, inviteTextiOS, t }) {
    const dispatch = useDispatch();
    const { classes } = useStyles();
    const [isClicked, setIsClicked] = useState(false);
    const encodedInviteSubject = encodeURIComponent(inviteSubject);
    const encodedInviteText = encodeURIComponent(inviteText);
    const encodedInviteTextiOS = encodeURIComponent(inviteTextiOS);
    const encodedDefaultEmailText = isIosMobileBrowser() ? encodedInviteTextiOS : encodedInviteText;
    useEffect(() => {
        mounted = true;
        return () => {
            mounted = false;
        };
    }, []);
    function _onCopyText() {
        copyText(inviteText);
    }
    function _onCopyTextKeyPress(e) {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            copyText(inviteText);
        }
    }
    function renderEmailIcons() {
        const PROVIDER_MAPPING = [{
                icon: IconEnvelope,
                tooltipKey: "addPeople.defaultEmail",
                url: `mailto:?subject=${encodedInviteSubject}&body=${encodedDefaultEmailText}`
            }, {
                icon: IconGoogle,
                tooltipKey: "addPeople.googleEmail",
                url: `https://mail.google.com/mail/?view=cm&fs=1&su=${encodedInviteSubject}&body=${encodedInviteText}`
            }, {
                icon: IconOffice365,
                tooltipKey: "addPeople.outlookEmail",
                url: `https://outlook.office.com/mail/deeplink/compose?subject=${encodedInviteSubject}&body=${encodedInviteText}`
            }, {
                icon: IconYahoo,
                tooltipKey: "addPeople.yahooEmail",
                url: `https://compose.mail.yahoo.com/?To=&Subj=${encodedInviteSubject}&Body=${encodedInviteText}`
            }];
        return (React.createElement(React.Fragment, null, PROVIDER_MAPPING.map(({ icon, tooltipKey, url }, idx) => (React.createElement(Tooltip, { content: t(tooltipKey), key: idx, position: "top" },
            React.createElement("a", { "aria-label": t(tooltipKey), className: classes.iconContainer, href: url, rel: "noopener noreferrer", target: "_blank" },
                React.createElement(Icon, { colorInClass: true, src: icon })))))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.container },
            React.createElement("p", { className: classes.label }, t("addPeople.shareInvite")),
            React.createElement("div", { className: classes.iconRow },
                React.createElement(Tooltip, { content: t("addPeople.copyInvite"), position: "top" },
                    React.createElement("div", { "aria-label": t("addPeople.copyInvite"), className: classes.iconContainer, onClick: _onCopyText, onKeyPress: _onCopyTextKeyPress, role: "button", tabIndex: 0 },
                        React.createElement(Icon, { colorInClass: true, src: IconCopy }))),
                renderEmailIcons()))));
}
export default translate(InviteByEmailSection);
